export default __webpack_public_path__ + "static/media/pot5.42119141.svg";